import {Component, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-slide-toggle',
  templateUrl: './slide-toggle.component.html',
  styleUrls: ['./slide-toggle.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SlideToggleComponent,
    },
  ],
})
export class SlideToggleComponent implements ControlValueAccessor {
  @Input() size: 'small' | 'normal' = 'normal';
  @Input() labelText = '';
  @Input() labelPosition: 'left' | 'right' = 'right';

  value = false;
  touched = false;
  disabled = false;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange = (value: boolean) => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched = () => {};

  writeValue(value: boolean) {
    this.value = value;
  }

  registerOnChange(onChange: (value: boolean) => void) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: () => void) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  onInputChange(event: Event) {
    this.markAsTouched();
    if (!this.disabled) {
      this.value = (event.target as HTMLInputElement).checked;
      this.onChange(this.value);
    }
  }
}
